import { useState } from "react";
import useTodoList from "../useTodoList";

// Ajout d'une tâche : le choix dans le catalogue du produit et « Ajouter » ;
// le champ de note n'apparaît qu'une fois la tâche choisie.
const AddTodoForm = ({ addTodo }) => {
  const { availableTasks } = useTodoList();
  const [taskId, setTaskId] = useState("");
  const [text, setText] = useState("");

  const onSubmit = (evenement) => {
    evenement.preventDefault();
    if (!taskId) return;
    addTodo({ taskId, isDone: false, text: text.trim() });
    setTaskId("");
    setText("");
  };

  return (
    <form className="tl-ajout" onSubmit={onSubmit}>
      <label className="tl-ajout__champ">
        <span className="tl-sr-only">Tâche à ajouter</span>
        <select className="tl-ajout__select" name="taskId" value={taskId} onChange={(evenement) => setTaskId(evenement.target.value)}>
          <option value="">Ajouter une tâche…</option>
          {(availableTasks || []).map((tache) => (
            <option key={tache.id} value={String(tache.id)}>
              {tache.name}
            </option>
          ))}
        </select>
      </label>
      <button type="submit" className="tl-bouton" disabled={!taskId}>
        <i className="fa fa-plus" aria-hidden="true" />
        Ajouter
      </button>
      {taskId && (
        <input
          type="text"
          className="tl-ajout__note"
          name="text"
          value={text}
          onChange={(evenement) => setText(evenement.target.value)}
          placeholder="Note (facultatif)"
          aria-label="Note (facultatif)"
        />
      )}
    </form>
  );
};

export default AddTodoForm;
